module.exports = __webpack_public_path__ + "static/img/chat-ai.603eacc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent-ai/chat-ai.png
// module id = WH6s
// module chunks = 20